import PropTypes from 'prop-types';

const MainPropType = {
  children: PropTypes.node,
};

export default MainPropType;
